import React from 'react';
import classNames from 'classnames';

import css from './IconPlus.module.css';

/**
 * Chevron icon used as expand/collapse indicator in FilterPlain sections.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {boolean} [props.isOpen] - Whether the section is expanded
 * @returns {JSX.Element}
 */
const IconPlus = props => {
  const { className, rootClassName, isOpen = true } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      role="none"
    >
      <polyline
        className={classNames(css.chevron, { [css.chevronOpen]: isOpen })}
        points="2,4 6,8 10,4"
        fill="none"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconPlus;
